import { SignInIcon as PhosphorSignInIcon } from "@phosphor-icons/react/dist/ssr/SignIn";

import { createAppIcon } from "@/components/createAppIcon";

export const LoginIcon = /* @__PURE__ */ createAppIcon(PhosphorSignInIcon);
